import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '../auth/AuthProvider';
import { PageHeader } from '../components/common/PageHeader';
import { useIsSuperuser } from '../hooks/useIsSuperuser';
import { useOrgContext } from '../hooks/useOrgContext';

export const Route = createFileRoute('/settings')({ component: SettingsPage });

function SettingsPage() {
  const { email, name, signOut } = useAuth();
  const { orgId, orgName } = useOrgContext();
  const isSuper = useIsSuperuser();

  return (
    <>
      <PageHeader title="Settings" />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr)',
          gap: 'var(--sp-4)',
          maxWidth: 720,
        }}
      >
        <div className="card">
          <div className="card-header">
            <span className="t-mono-label">PROFILE</span>
            <h3 className="t-h3">{name ?? email ?? 'You'}</h3>
          </div>
          <div className="card-body">
            <KV label="Email">{email ?? '—'}</KV>
            <KV label="Name">{name ?? '—'}</KV>
            <KV label="Roles">
              {isSuper ? (
                <span className="badge badge--tool">Superuser</span>
              ) : (
                <span className="badge badge--neutral">Member</span>
              )}
            </KV>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <span className="t-mono-label">ORGANIZATION</span>
            <h3 className="t-h3">{orgName ?? '(none)'}</h3>
          </div>
          <div className="card-body">
            <KV label="Org name">{orgName ?? '—'}</KV>
            <KV label="Org ID" mono={true}>
              {orgId ?? '—'}
            </KV>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <button
              type="button"
              className="btn btn--destructive"
              onClick={async () => {
                try {
                  await signOut();
                } catch (err) {
                  console.error(err);
                }
              }}
            >
              Sign out
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

function KV({
  label,
  children,
  mono,
}: {
  label: string;
  children: React.ReactNode;
  mono?: boolean;
}) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '180px 1fr',
        padding: 'var(--sp-2) 0',
        borderTop: '1px solid var(--border-subtle)',
        alignItems: 'baseline',
        gap: 'var(--sp-3)',
      }}
    >
      <span className="t-secondary">{label}</span>
      <span className={mono ? 't-mono' : ''} style={{ color: 'var(--text-primary)' }}>
        {children}
      </span>
    </div>
  );
}
